import httpClient from './httpClient'

const END_POINT = '/customerresources'

const RingbaTokensAPI = {

  /**
   * Get all Ringba API tokens for an account
   * @param {string} accountId - The account ID
   * @returns {Promise<RingbaTokens.ListTokensResponse>} Promise resolving to array of token metadata
   */
  async listTokens(accountId) {
    return await httpClient.get(`${END_POINT}/${accountId}/ringba-tokens`)
  },

  /**
   * Create a new Ringba API token for an account
   * @param {string} accountId - The account ID
   * @param {RingbaTokens.CreateTokenRequest} tokenDetails - Token creation details
   * @returns {Promise<RingbaTokens.CreateTokenResponse>} Promise resolving to creation result
   */
  async createToken(accountId, tokenDetails) {
    return await httpClient.post(`${END_POINT}/${accountId}/ringba-tokens`, tokenDetails)
  },

  /**
   * Delete a specific Ringba API token
   * @param {string} accountId - The account ID
   * @param {string} tokenId - The token ID to delete
   * @returns {Promise<RingbaTokens.DeleteTokenResponse>} Promise resolving to deletion result
   */
  async deleteToken(accountId, tokenId) {
    return await httpClient.delete(`${END_POINT}/${accountId}/ringba-tokens/${tokenId}`)
  },

  /**
   * Set a specific Ringba API token as the default
   * @param {string} accountId - The account ID
   * @param {string} tokenId - The token ID to set as default
   * @returns {Promise<void>} Promise resolving when token is set as default
   */
  async setDefaultToken(accountId, tokenId) {
    return await httpClient.post(`${END_POINT}/${accountId}/ringba-tokens/${tokenId}/default`)
  }
}

export default RingbaTokensAPI